import React from 'react';

import Heading from 'grommet/components/Heading';
import Header from 'grommet/components/Header';
import Article from 'grommet/components/Article';
import Box from 'grommet/components/Box';
import Footer from 'grommet/components/Footer';
import Anchor from 'grommet/components/Anchor';
import Button from 'grommet/components/Button';
import Status from 'grommet/components/icons/Status';

export default function() {
  return (
    <Article align="center" full justify="center">
      <Header pad={{between: 'small' }} align="center">
        <Status value="ok" />
        <Heading strong direction="row" tag="h2" margin="none">
          <em>Your field has been submitted!</em>
        </Heading>
      </Header>
      <Box size="medium">
        <Box align="center">
          <p>What would you like to do next?</p>
        </Box>
        <Footer justify="between">
          <Button primary path="/entry" label="Submit another field"/>
          <Anchor path="/">Exit</Anchor>
        </Footer>
      </Box>
    </Article>
  )
}



// WEBPACK FOOTER //
// ./src/containers/SubmitSuccess.js